import choVayConst from "constants/choVayConst";
import { LaiSuatText2 } from "constants/choVayConst";
import React, { useState, useEffect } from "react";
import NhanVayApi from "service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { currentDate } from "utils/formatDate";

export const ThongTinHopDong = ({ NhanVayId, item }) => {
  const initThongTinTra = {
    NhanVayId: 0,
    TenChuNo: "",
    NgaySinh: null,
    DiaChi: "",
    MaHopDong: "",
    NgayVay: "",
    NgayTra: "",
    SoTienVay: 0,
    TongTienLai: 0,
    TongTienPhaiTra: 0,
    SoTienDaTra: 0,
    SoTienConPhaiTra: 0,
    SoNgayTraLai: 0,
    KieuTraLai: "",
  };
  const [dataThongTinTra, setDataThongTinTra] = useState(initThongTinTra);

  const initHopDong = {
    Address: "",
    AddressCmt: "",
    AnhKhachHang: "",
    BeforeAfter: 0,
    Birthday: "01/01/1900 00:00:00",
    Cmt: "",
    CountTypePaid: 0,
    CustomerId: 0,
    DateCmt: "01/01/1900 00:00:00",
    DsTaiSanNhanVay: [],
    FileDinhKems: null,
    GhiChu: "",
    GiayToTheChap: "",
    KieuLaiSuat: 0,
    LaiNgay: 0,
    MaNhanVay: "",
    NgayTao: "01/01/1900 00:00:00",
    NgayTra: "01/01/1900 00:00:00",
    NgayVay: "01/01/1900 00:00:00",
    NguoiTao: "",
    NhanVayID: 0,
    Phone: "",
    SoLanTra: 0,
    Sotienvay: 0,
    TenKhachHang: "",
    TypePaid: 0,
  };
  const [hopdong, setDataHopDong] = useState(initHopDong);
  useEffect(() => {
    LayThongTinTra();
    ChiTietHopDong();
  }, []);
  const ChiTietHopDong = () => {
    NhanVayApi.getChiTietHopDong1(NhanVayId).then((response) => {
      setDataHopDong({
        Address: response.data.Address,
        AddressCmt: response.data.AddressCmt,
        AnhKhachHang: response.data.AnhKhachHang,
        BeforeAfter: response.data.BeforeAfter,
        Birthday: response.data.Birthday,
        Cmt: response.data.Cmt,
        CountTypePaid: response.data.CountTypePaid,
        CustomerId: response.data.CustomerId,
        DateCmt: response.data.DateCmt,
        DsTaiSanNhanVay: response.data.DsTaiSanNhanVay,
        FileDinhKems: response.data.FileDinhKems,
        GhiChu: response.data.GhiChu,
        GiayToTheChap: response.data.GiayToTheChap,
        KieuLaiSuat: response.data.KieuLaiSuat,
        LaiNgay: response.data.LaiNgay,
        MaNhanVay: response.data.MaNhanVay,
        NgayTao: response.data.NgayTao,
        NgayTra: response.data.NgayTra,
        NgayVay: response.data.NgayVay,
        NguoiTao: response.data.NguoiTao,
        NhanVayID: response.data.NhanVayID,
        Phone: response.data.Phone,
        SoLanTra: response.data.SoLanTra,
        Sotienvay: response.data.Sotienvay,
        TenKhachHang: response.data.TenKhachHang,
        TypePaid: response.data.TypePaid,
      });
    });
  };
  const LayThongTinTra = () => {
    NhanVayApi.getChiTietHopDong(NhanVayId, currentDate()).then((response) => {
      //Lấy được thông tin tất toán hợp đồng
      setDataThongTinTra({
        ...dataThongTinTra,
        NhanVayId: NhanVayId,
        TenChuNo: response.data.TenChuNo,
        NgaySinh: response.data.NgaySinh,
        DiaChi: response.data.DiaChi,
        MaHopDong: response.data.MaHopDong,
        NgayVay: response.data.NgayVay,
        NgayTra: response.data.NgayTra,
        SoTienVay: response.data.SoTienVay,
        TongTienLai: response.data.TongTienLai,
        TongTienPhaiTra: response.data.TongTienPhaiTra,
        SoTienDaTra: response.data.SoTienDaTra,
        SoTienConPhaiTra: response.data.SoTienConPhaiTra,
        SoNgayTraLai: response.data.SoNgayTraLai,
        KieuTraLai: response.data.KieuTraLai,
      });
    });
  };
  return (
    <div className="list-thongtinhopdong">
      <div className="row">
        <div className="col-md-12 col-sm-12">
          <div class="from-thongtintra" style={{ marginTop: "10px" }}>
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  {" "}
                  Thanh toán cho hợp đồng:{" "}
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span className="color-xanh-bold">
                    {dataThongTinTra.MaHopDong}
                  </span>
                </div>
              </div>
            </p>
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Chủ nợ:{" "}
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>{dataThongTinTra.TenChuNo}</span>
                </div>
              </div>
            </p>
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Ngày sinh:{" "}
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>{getDate(dataThongTinTra.NgaySinh)}</span>
                </div>
              </div>
            </p>
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Địa chỉ:{" "}
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>{dataThongTinTra.DiaChi}</span>
                </div>
              </div>
            </p>
          </div>
          <div class="from-thongtintra">
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Số tiền vay:
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span className="color-do-bold">
                    {" "}
                    {formatNumber(dataThongTinTra.SoTienVay)}(vnđ)
                  </span>
                </div>
              </div>
            </p>
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Ngày vay:
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>{getDate(dataThongTinTra.NgayVay)}</span>
                </div>
              </div>
            </p>
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Ngày trả:
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>{getDate(dataThongTinTra.NgayTra)}</span>
                </div>
              </div>
            </p>{" "}
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Tổng tiền lãi:{" "}
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>{formatNumber(dataThongTinTra.TongTienLai)} (vnđ)</span>
                </div>
              </div>
            </p>{" "}
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Kiểu trả lãi:{" "}
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>
                    {choVayConst.BeforeAfterText[hopdong.BeforeAfter]}
                  </span>
                </div>
              </div>
            </p>
            <p>
              {" "}
              {hopdong.KieuLaiSuat === 3 ? (
                <div className="row">
                  <div className="col-label-thong-tin-hd color7-bold">
                    Kiểu trả lãi:{" "}
                  </div>
                  <div className="col-3 text-left color7 color-cam-bold">
                    <span>
                      {choVayConst.KieuLaiSuatText[hopdong.KieuLaiSuat]}:{" "}
                      {item.LaiSuat.replace(/[/]Tháng$/, "")}
                    </span>
                  </div>
                </div>
              ) : hopdong.KieuLaiSuat === 2 ? (
                <div className="row">
                  <div className="col-label-thong-tin-hd color7-bold">
                    Kiểu trả lãi:{" "}
                  </div>
                  <div className="col-3 text-left color7 color-cam-bold">
                    <span>
                      {choVayConst.KieuLaiSuatText[hopdong.KieuLaiSuat]}:{" "}
                      {item.LaiSuat}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-label-thong-tin-hd color7-bold">
                    Kiểu trả lãi:{" "}
                  </div>
                  <div className="col-3 text-left color7 color-cam-bold">
                    <span>
                      {choVayConst.KieuLaiSuatText[hopdong.KieuLaiSuat]}:{" "}
                      {LaiSuatText2(hopdong, hopdong.KieuLaiSuat)}
                    </span>
                  </div>
                </div>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
